import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import { SettingsRoutes } from 'support/types';

type Props = {
  label: string;
};

export const MasterdataLink = ({ label }: Props) => {
  return (
    <a
      href={SettingsRoutes.productMasterdata}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-sm font-medium text-gray-900 underline"
      onMouseDown={(event) => event.preventDefault()}
    >
      {label}
      <ArrowTopRightOnSquareIcon className="size-4" />
    </a>
  );
};
